import React from "react";
import "./Home.css";
import resume from "../assets/keerthanas_FrondendDeveloper_resume.pdf";

function Home() {
  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar">
        <div className="logo">Portfolio</div>
        <ul className="nav-links">
          <li><a href="#home" className="active">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#education">Education</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>

      {/* HOME SECTION */}
      <section className="home" id="home">
        <div className="home-left">

          {/* TEXT ANIMATIONS */}
          <p className="hello reveal delay-1">
            HI! I'M KEERTHANA
          </p>

          <h1 className="hero-title reveal delay-2">
            FRONTEND DEVELOPER <br />
          </h1>

          <p className="description reveal delay-3">
            Motivated and enthusiastic Frontend Developer with knowledge of HTML, CSS, JavaScript, Bootstrap, and React.js. Passionate about building responsive and user-friendly web applications. Seeking an opportunity to apply technical skills and contribute to real-world projects while continuously learning and growing in the field of web development.
          </p>

          {/* BUTTONS */}
          <div className="home-buttons reveal delay-4">
        <a href={resume} target="_blank" rel="noopener noreferrer" className="resume-btn">
  View Resume
</a>


            <a
              href="#contact"
              className="btn secondary"
            >
              Let’s Talk
            </a>
          </div>

        </div>
      </section>
    </>
  );
}

export default Home;
